module.exports = __webpack_public_path__ + "static/trailWinner-366b272d40b7c9b70ce5b70a842b51f6.gif";